import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { TranslocoModule } from '@jsverse/transloco';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { FurtherQualificationDialogComponent } from './further-qualification-dialog/further-qualification-dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { InfoComponent } from './info/info.component';
import { ApproveComponent } from './approve/approve.component';
import { ContactRequestDialogComponent } from './contact-request-dialog/contact-request-dialog.component';
import { InitalConsentDialogComponent } from './inital-consent-dialog/inital-consent-dialog.component';
import { SharedRegistrationModule } from '@markant-platform/shared/registration';

@NgModule({
  imports: [
    CommonModule,
    MarkantElementsModule,
    ModalBridgeComponent,
    TranslocoModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    SharedRegistrationModule,
  ],
  declarations: [
    ApproveComponent,
    InfoComponent,
    ErrorDialogComponent,
    FurtherQualificationDialogComponent,
    ConsentDialogComponent,
    ContactRequestDialogComponent,
    InitalConsentDialogComponent,
  ],
  exports: [
    ApproveComponent,
    InfoComponent,
    ErrorDialogComponent,
    FurtherQualificationDialogComponent,
    ConsentDialogComponent,
    ContactRequestDialogComponent,
  ],
})
export class SharedDialogFeatureModule {}
